
export const DesignPackagesData = [
    {
        id: 1,
        name: "Basic Design",
        price: "₹15 / sq.ft",
        description: "Essential drawings for getting started.",
        features: [
            "2D Floor Plan",
            "Furniture Layout",
            "1 Revision"
        ],
        recommended: false
    },
    {
        id: 2,
        name: "Standard Design",
        price: "₹35 / sq.ft",
        description: "Complete design solution for your home.",
        features: [
            "2D Floor Plan",
            "3D Elevation",
            "Structural Drawings",
            "Electrical Layout",
            "Plumbing Layout",
            "3 Revisions"
        ],
        recommended: true
    },
    {
        id: 3,
        name: "Premium Design",
        price: "₹60 / sq.ft",
        description: "Detailed architectural and interior planning.",
        features: [
            "2D Floor Plan",
            "3D Elevation & Walkthrough",
            "Structural Analysis",
            "MEP Drawings (Mech, Elec, Plumbing)",
            "Interior 3D Views",
            "Unlimited Revisions"
        ],
        recommended: false
    }
];

export const ConstructionPackagesData = [
    {
        id: 1,
        name: "Basic Package",
        price: "₹1,650 / sq.ft",
        description: "Essential construction services for budget-friendly homes.",
        features: [
            "Structure: RCC Framed Structure",
            "Steel: Fe 550 TMT Bars",
            "Cement: OPC 53 Grade",
            "Flooring: Vitrified Tiles (₹40/sq.ft)",
            "Doors: Flush Doors",
            "Windows: Aluminium Sliding",
            "Painting: Emulsion Paint",
            "Electrical: Standard ISI Wires & Switches",
            "Plumbing: Standard PVC Pipes"
        ],
        recommended: false
    },
    {
        id: 2,
        name: "Premium Package",
        price: "₹1,950 / sq.ft",
        description: "High-quality materials for a modern and durable home.",
        features: [
            "Structure: RCC Framed Structure",
            "Steel: Fe 550D TMT Bars (Tata/Jindal)",
            "Cement: OPC 53 Grade (Ultratech/ACC)",
            "Flooring: Vitrified Tiles (₹60/sq.ft)",
            "Doors: Teak Wood Main Door, others Flush",
            "Windows: UPVC Windows",
            "Painting: Premium Emulsion",
            "Electrical: Branded Wires (Finolex/Polycab)",
            "Plumbing: CPVC & UPVC (Astral/Ashirvad)"
        ],
        recommended: true
    },
    {
        id: 3,
        name: "Luxury Package",
        price: "₹2,350 / sq.ft",
        description: "Top-tier finishes and premium brands for a luxurious lifestyle.",
        features: [
            "Structure: Advanced RCC Design",
            "Steel: Fe 550D TMT Bars (Tata/Jindal)",
            "Cement: Premium Grade",
            "Flooring: Italian Marble / Granite (₹120/sq.ft)",
            "Doors: Teak Wood Frames & Shutters",
            "Windows: Premium UPVC / Wooden",
            "Painting: Royal Luxury Emulsion",
            "Electrical: Premium Modular Switches",
            "Plumbing: Premium Bathroom Fittings (Jaquar/Kohler)",
            "Smart Home Automation Provisions"
        ],
        recommended: false
    }
];
